import {
  getRequest,
  postRequest,
  deleteRequest,
  fileUploadRequest,
  patchRequest,
  deleteBulkRequest,
} from "NetworkCall";

import {
  APP_API_KEY,
  INSTANCE_URL,
  itemCount,
  MAIN_URL,
  DEVELOPMENT_TYPE,
} from "Constants";
export const LEADERBOARD_USER_LIST = "LEADERBOARD_USER_LIST";
export const LEADERBOARD_EDIT_USER_LIST = "LEADERBOARD_EDIT_USER_LIST"; // FETCH FROM APPUSERS
export const LEADERBOARD_EXTRAPOINTS_MODAL = "LEADERBOARD_EXTRAPOINTS_MODAL";
export const LEADERBOARD_ALL_CHALLENGES = "LEADERBOARD_ALL_CHALLENGES"; // fetches all challenges in the event
export const LEADERBOARD_LOG_LIST_ALL = "LEADERBOARD_LOG_LIST_ALL";

export function fetchLeaderboardUserList(
  session,
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "leaderboarduserlist",
        eventid: session.eventid,
        limit: itemCount,
        offset: offset,
      },
      session,
      dispatch,
      (response) => {
        if (
          response.resource.data[0].id == null ||
          response.resource.data[0].id == "null" ||
          response.resource.data[0].id == ""
        ) {
          dispatch({
            type: LEADERBOARD_USER_LIST,
            payload: { data: {}, count: 0 },
          });
        } else {
          dispatch({
            type: LEADERBOARD_USER_LIST,
            payload: {
              data: response.resource.data,
              count: response.resource.count,
            },
          });
        }

        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function searchUser(
  session,
  search = "",
  pageCount = 0,
  countPerPage = 0,
  callback
) {
  var perPage = itemCount;
  if (countPerPage !== 0) perPage = countPerPage;

  var offset = pageCount == 1 ? 0 : (pageCount - 1) * perPage;
  let searchQuery = "";
  if (search == "" || search == "null" || search == null) {
    searchQuery = "";
  } else {
    searchQuery = ` AND (A.username like '%${search}%')`;
  }

  var url = `${INSTANCE_URL}/api/v2/gamification_admin_script`;

  return (dispatch) => {
    postRequest(
      url,
      {
        requesttype: "leaderboarduserlist",
        eventid: session.eventid,
        limit: itemCount,
        offset: offset,
        searchQuery: searchQuery,
      },
      session,
      dispatch,
      (response) => {
        dispatch({
          type: LEADERBOARD_USER_LIST,
          payload: {
            data: response.resource.data,
            count: response.resource.data.length,
          },
        });
        callback({ status: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchUserListEditLeaderBoard(session, userid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?include_count=true&admin=1&filter=eventid=${session.eventid}&filter=appuserid=${userid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // dispatch({
        //   type: LEADERBOARD_EDIT_USER_LIST,
        //   payload: { data: response.resource, count: response.meta.count },
        // });
        callback({ data: response.resource });
      },
      (error) => {}
    );
  };
}

/*** API call to delete from gamification leader board Table With Eventid ***/
export function resetGamificationPoints(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_user_points_log?filter=(${filter})`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0 });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}

// controls extra points modal rendering
export const addExtraPointsModal = (option) => {
  return {
    type: LEADERBOARD_EXTRAPOINTS_MODAL,
    payload: option,
  };
};

// action for extra bonus point adding
export const addExtraPoints = (session, value, callback) => {
  let // postFilter = encodeURI(`(eventid=${session.eventid})`),
    // postUrl = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_user_points_log`,
    postUrl = `${INSTANCE_URL}/api/v2/gamification_admin_script`,
    postBody = { ...value, requesttype: "addExtraPoints" };

  return (dispatch) => {
    postRequest(
      postUrl,
      postBody,
      session,
      dispatch,
      (res) => {
        callback({
          success: 1,
          case: `${res.create_success}${res.update_success}`,
          response: res,
        });
      },
      (error) => {
        // callback({ success: 0, message: error });
      }
    );
  };
};

// action to list all challenges
export const listAllChallenges = (session, callback) => {
  let fetchFilter = encodeURI(
      `((eventid=${session.eventid})AND(rewardtype=point)AND(isactive=1))`
    ),
    fetchFields = "id,challengename,challengedesc,points,isrecurring",
    fetchUrl = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_challenge?include_count=true&fields=${fetchFields}&filter=${fetchFilter}`;

  return (dispatch) => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      (res) => {
        dispatch({
          type: LEADERBOARD_ALL_CHALLENGES,
          payload: { count: res.meta.count, data: res.resource },
        });
        callback({ success: 1, count: res.meta.count, data: res.resource });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export function fetchLeaderBoardLogall(session, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var related =
    "appuser_by_userid,gamification_challenge_by_challengeid&appuser_by_userid.fields=username,email,usercategory&gamification_challenge_by_challengeid.fields=challengename";
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/gamification_user_points_log?filter=(${filter})&related=${related}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);
        dispatch({
          type: LEADERBOARD_LOG_LIST_ALL,
          payload: { data: response.resource },
        });
        callback({ data: response.resource, success: 1 });
      },
      (error) => {}
    );
  };
}
